<template>
    <main class="dynamic-page">
        <div v-if="!loading">
            <StructureSection
                v-for="(section, index) in data"
                :key="index"
                :count="index"
                :content="section"
            />
        </div>

        <div v-else class="min-h-[800px]">
            <div class="container m-auto py-12">
                <div class="flex flex-col gap-4">
                    <MiscSkeleton size="large" />
                    <MiscSkeleton size="large" />
                    <MiscSkeleton size="medium" />
                    <MiscSkeleton size="large" />
                    <MiscSkeleton size="large" />
                    <MiscSkeleton size="medium" />
                    <MiscSkeleton size="large" />
                    <MiscSkeleton size="medium" />
                    <MiscSkeleton size="large" />
                    <MiscSkeleton size="large" />
                    <MiscSkeleton size="medium" />
                    <MiscSkeleton size="medium" />
                    <MiscSkeleton size="medium" />
                </div>
            </div>
        </div>
    </main>
</template>
<script setup lang="ts">
import {useI18n} from "vue-i18n";
import {useCms} from '#imports'
import { normalizeSlashes } from '@/utils/helper'

const { t } = useI18n()
const config = useRuntimeConfig().public
const head = useLocaleHead()
const { cmsData, fetchCms } = useCms()
const data = ref(false)
const loading = ref(true)

const route = useRoute()
const { isLocalisedRoute } = useLocalisation()
const routeLocale = isLocalisedRoute(route.path)

let canonicalUrl = config?.appBaseUrl + route?.path

if (routeLocale) {
    canonicalUrl = config?.appBaseUrl + routeLocale
}

canonicalUrl = normalizeSlashes(canonicalUrl)

onMounted(async () => {
    await fetchCms(config.recipeOverview)
    loading.value = false
    data.value = cmsData.value
})

useHead({
    title: t("recipe.title"),
    link: [
        {
            rel: 'canonical',
            href: canonicalUrl
        }
    ]
})
</script>
